import React from 'react';
import PolicyPage from './PolicyPage';

export default function CookiePolicy() {
  return (
    <PolicyPage title="Cookie Policy">
      <p className="text-sm text-secondary-500">Last updated: {new Date().toLocaleDateString('en-US')}</p>
      <p>
        This policy explains how Driscollland uses cookies and similar technologies on our website.
      </p>
      <h2 className="text-xl font-semibold text-secondary-900 mt-6 mb-2">What we use</h2>
      <p>
        We may use essential cookies to keep you logged in and remember your preferences. We may also use analytics cookies to understand how visitors use our site.
      </p>
      <h2 className="text-xl font-semibold text-secondary-900 mt-6 mb-2">Your choices</h2>
      <p>
        You can control or delete cookies through your browser settings. Disabling certain cookies may affect how the site works.
      </p>
      <h2 className="text-xl font-semibold text-secondary-900 mt-6 mb-2">Contact</h2>
      <p>
        For questions about cookies, contact driscolledward@att.net.
      </p>
    </PolicyPage>
  );
}
